import { useLocation } from 'react-router-dom';

import { cn } from '@/lib/utils';

export function Footer() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <footer className="border-t bg-background">
      <div
        className={cn(
          'flex h-12 items-center justify-between text-xs text-muted-foreground',
          isHome ? 'mx-auto w-full max-w-6xl px-4' : 'container',
        )}
      >
        <span>CV Creator - privacy first</span>
        <span>v0.0.1</span>
      </div>
    </footer>
  );
}
